export default {"src":"/_next/static/media/Share-button-W.b2155471.svg","height":52,"width":170,"blurWidth":0,"blurHeight":0};